import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const PartnerExportService = {
  async recordCompletedExport({ menu, format, filters = {}, rowCount = 0 }) {
    try {
      const response = await axios.post(`${apiUrl}/Partner/PartnerExport/history`, {
        menu,
        format,
        filters,
        row_count: rowCount,
      });
      return response?.data?.status === true;
    } catch (error) {
      console.error('Partner export history failed:', error);
      return false;
    }
  },
};

export default PartnerExportService;
